import { render, staticRenderFns } from "./SubTypeSelect.vue?vue&type=template&id=22a599b1"
import script from "./SubTypeSelect.js?vue&type=script&lang=js&external"
export * from "./SubTypeSelect.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports